import React from 'react';
import {useTranslation} from 'react-i18next';
import {ETooltip} from 'webapp-lib/Components';

import {Warning} from '_/assets/images';

import {
  FilteredOutWarning,
  FiltersLabelSubtextWrapper,
  OptionFilterInfoWrapper,
} from './OptionFilterInfo.styles';

export const OptionFilterInfo = ({
  optionFilterText,
  showFilteredOutWarning,
  filteredOutWarningText,
}: {
  optionFilterText: string;
  showFilteredOutWarning?: boolean;
  filteredOutWarningText?: string;
}): React.ReactElement => {
  const {t} = useTranslation('common');

  return (
    <OptionFilterInfoWrapper>
      {t('optionFilterInfo.searchFiltersLabelSubtext')}
      <FiltersLabelSubtextWrapper>
        {optionFilterText}
      </FiltersLabelSubtextWrapper>
      {showFilteredOutWarning ? (
        <FilteredOutWarning>
          <ETooltip
            title={
              filteredOutWarningText ??
              t('optionFilterInfo.filteredOutWarningText')
            }
          >
            <Warning />
          </ETooltip>
        </FilteredOutWarning>
      ) : null}
    </OptionFilterInfoWrapper>
  );
};
